import(/* webpackMode: "eager" */ "/app/hub/src/app/[accountId]/folder/error.tsx");
